import { z } from "zod"

export const patientProfileSchema = z.object({
  heightInCentimeters: z.number().min(50).max(300),
  weightInKilograms: z.number().min(20).max(500),
  numberOfFetuses: z.number().int().min(1).max(4),
  estimatedDateOfDelivery: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date"),
})

export const medicationsSchema = z.object({
  hasMedications: z.boolean(),
  medications: z.array(z.object({ name: z.string().min(1) })).optional(),
})

export const remindersSchema = z.object({
  reminderTimes: z.array(z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "Use HH:mm format")),
})

export const shippingSchema = z.object({
  countryCode: z.string().min(2),
  state: z.string().min(1),
  city: z.string().min(1),
  zipCode: z.string().min(1),
  address1: z.string().min(1),
  address2: z.string().optional(),
})

export type PatientProfileFormData = z.infer<typeof patientProfileSchema>
export type MedicationsFormData = z.infer<typeof medicationsSchema>
export type RemindersFormData = z.infer<typeof remindersSchema>
export type ShippingFormData = z.infer<typeof shippingSchema>
